import { AgentEffects } from './agent.effects'
import { AppEffects } from './app.effects'
import { PropertyEffects } from './property.effects'

export const effects: any[] = [AgentEffects, AppEffects, PropertyEffects]

export * from './agent.effects'
export * from './app.effects'
export * from './property.effects'
